/* eslint-disable import/prefer-default-export */

/**
 * planIds: ['core', 'plus'];
 *
 * planFeaturesBefore: [{ ... , plansDetails: { standard: ... , premium: ... , core: ... , plus: ... }}]
 * planFeaturesAfter: [{ ... , plansDetails: { core: ... , plus: ... }}]
 */
export function filterFeatureDetails(plans, planFeatures) {
  if (plans.length === 0) return [];

  const planIds = plans.map((plan) => plan.planNameId);

  return planFeatures
    .map((feature) => {
      if (feature.titleLabel) return feature; // ignore title labels

      if (!feature.plansDetails) return feature;

      const filteredEntries = Object.entries(feature.plansDetails).filter(([planId]) => planIds.includes(planId));

      if (filteredEntries.length === 0) return null;

      return {
        ...feature,
        plansDetails: Object.fromEntries(filteredEntries),
      };
    })
    .filter(Boolean);
}
